<script setup lang="ts">
defineOptions({ name: 'AuthEmail' })
import { BForm, BInput } from 'best-modules/components'
import { useSso } from '../sso'
import { getErrorMessages } from '@/utils/helpers'
const { credentials, validation, submitEmail } = useSso()
</script>
<template>
  <b-form
    autocomplete="on"
    class="sso-form"
    hide-action-buttons
    :submit="submitEmail">
    <label class="sso-form__email-label" for="sso-email">
      Корпоративна пошта
    </label>
    <b-input
      id="sso-email"
      v-model="credentials.email"
      autocomplete="username"
      class="sso-field"
      :error-messages="getErrorMessages(validation.email)"
      name="username"
      placeholder="name@company.ua"
      type="email"
      @update:model-value="validation.email.$reset()">
      <template #prepend-inner>
        <v-icon color="text-muted" icon="mdi-email-outline" size="18"></v-icon>
      </template>
    </b-input>
    <v-btn
      block
      class="sso-submit"
      color="primary"
      type="submit"
      :loading="$loading.isLoading('checkEmail')">
      Продовжити
    </v-btn>
  </b-form>
</template>
